module.exports = __webpack_public_path__ + "static/media/climate.104b3e68.png";